<div class="flex-column test">
    <div class="grow center gap-l">
        <span class="mat-caption">IP Network Region</span><mat-icon>swap_horiz</mat-icon><span class="mat-caption">Registered IP Endpoints</span>
    </div>

    <dashlet-table [columns]="columns" [dataSource]="dashlet.ipnrData" [tableHeightRows]="getTableSize()" [loading]="loading"></dashlet-table>
</div>
